export default __webpack_public_path__ + "static/iconFlor1-18d991a3fd1b69b5cdf4627a5c80f98e.png";